<template>
    <div id="crashMarkingTemplate">
        <div v-if="srp" id="crashXDiv" @click="openCrashMarkingForm()">
            X
        </div>
        <div v-else id="crashDiv" @click="openCrashMarkingForm()">
            remove vehicle
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'crashedCar',
            'page'
        ],
        computed: {
            srp() {
                return this.page == 'srp';
            }
        },
        methods: {
            openCrashMarkingForm() {
                this.$store.commit('toggleCrashMarkInitiated', this.crashedCar);
            }
        }
    }
</script>

<style>
    #crashXDiv {
        color: black;
        opacity: .25;
        position: absolute;
        bottom: calc(0 * var(--vh));
        left: calc(0 * var(--vh));
        width: calc(2.8 * var(--vw));
        height: calc(2.8 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: .85em;
    }

    #crashDiv {
        color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        height: inherit;
        width: fit-content;
        cursor: pointer;
    }

    .inmobile #crashXDiv {
        left: calc((100 * var(--vw)) - (2.8 * var(--vh)));
        width: calc(2.8 * var(--vh));
        height: calc(2.8 * var(--vh));
    }

    #crashXDiv:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>